import { ArrowDown } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { useAgentContext } from '@Providers';
import { cn } from '@Utils';

import { AGENT_DURATIONS, AGENT_EASING } from '../../../Helpers/Agents/animations';

interface ScrollToBottomButtonProps {
  isAtBottom: boolean;
  onScrollToBottom: () => void;
}

const ScrollToBottomButton = ({ isAtBottom, onScrollToBottom }: ScrollToBottomButtonProps) => {
  const { t } = useTranslation();
  const { mode } = useAgentContext();

  return (
    <AnimatePresence>
      {!isAtBottom && (
        <motion.button
          key="scroll-to-bottom"
          type="button"
          initial={{ opacity: 0, y: 8, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 8, scale: 0.95 }}
          transition={{ duration: AGENT_DURATIONS.fast, ease: AGENT_EASING.outExpo }}
          onClick={onScrollToBottom}
          aria-label={t('Agent.AriaScrollToBottom')}
          className={cn(
            'absolute bottom-4 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-[#fbfaf9] text-gray-500 shadow-md ring-1 ring-black/5 transition-colors hover:text-[#7c6cf6] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7c6cf6]/30',
            mode === 'fullscreen' ? 'right-[max(1rem,calc(50%-24rem))]' : 'right-4',
          )}>
          <ArrowDown className="h-4 w-4" strokeWidth={1.75} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToBottomButton;
